export enum GroupFieldType {
	General = 'general', // default for Group Renderer
}
